import React, { Fragment, useState } from 'react';
import { CAN_ADD_SCREENING_CLEARANCE_RULE_CONTENT } from '../../../auth/permissions';
import { Button } from 'react-bootstrap';

import './ScreeningClearanceRuleContents.scss';
import ContentInfo from './ContentInfo';
import {
  InternalApiEntityType,
  InternalApiScreeningClearanceRuleContent,
  InternalApiScreeningClearanceRuleContentStatusEnum,
} from '../../../api-internal';
import { screeningClearanceRuleContentApi } from '../../../apis';
import Table from '../../../table/Table';
import Has from '../../../auth/Has';
import ScreeningClearanceRuleContentModal from './ScreeningClearanceRuleContentModal';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ScreeningClearanceRuleContents = ({
  ruleHandle,
  entityType,
  fetchRule,
  contents,
}: {
  ruleHandle: string;
  entityType: InternalApiEntityType;
  fetchRule: any;
  contents: InternalApiScreeningClearanceRuleContent[];
}): React.JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const [content, setContent] = useState<InternalApiScreeningClearanceRuleContent | null>(null);

  const onComplete = async () => {
    fetchRule();
    setContent(null);
    setShowModal(false);
  };

  const addContent = async () => {
    setContent({
      status: InternalApiScreeningClearanceRuleContentStatusEnum.DRAFT,
      content: '',
    });
    setShowModal(true);
  };

  const editContent = async (content: InternalApiScreeningClearanceRuleContent) => {
    setShowModal(true);
    setContent(content);
  };

  const duplicateToDraft = async (toDuplicate: InternalApiScreeningClearanceRuleContent) => {
    const apiRuleContent: InternalApiScreeningClearanceRuleContent = {
      content: toDuplicate.content,
      status: InternalApiScreeningClearanceRuleContentStatusEnum.DRAFT,
      note: toDuplicate.note,
    };

    await screeningClearanceRuleContentApi.addRuleContent({
      handle: ruleHandle,
      internalApiScreeningClearanceRuleContent: apiRuleContent,
    });
    fetchRule();
    setContent(null);
  };

  return (
    <div>
      {contents && (
        <Table
          responsive={false}
          total={contents.length}
          page={0}
          size={contents.length}
          fetchPage={() => {
            // empty
          }}
          title={'Versions'}
          items={contents}
          header={() => (
            <tr>
              <th>Version</th>
              <th>Date modified</th>
              <th>Modifier</th>
              <th>Note</th>
              <th>Status</th>
              <th>Clearances</th>
              <th>Actions</th>
            </tr>
          )}
          actions={() => (
            <Has allPermissions={CAN_ADD_SCREENING_CLEARANCE_RULE_CONTENT}>
              <Button variant='info' size='sm' className='btn-white' onClick={() => addContent()}>
                <FontAwesomeIcon icon={faPlus} className='me-2' />
                New version
              </Button>
            </Has>
          )}
          body={(contents) =>
            contents.length > 0 &&
            contents.map((content, index) => (
              <Fragment key={content.id}>
                <ContentInfo
                  content={content}
                  ruleHandle={ruleHandle}
                  index={index}
                  onComplete={onComplete}
                  editContent={editContent}
                  duplicateAsDraft={duplicateToDraft}
                  entityType={entityType}
                />
              </Fragment>
            ))
          }
        />
      )}
      {content && (
        <ScreeningClearanceRuleContentModal
          ruleHandle={ruleHandle}
          show={showModal}
          content={content}
          onComplete={onComplete}
        />
      )}
    </div>
  );
};

export default ScreeningClearanceRuleContents;
